import React from 'react';
import View from "./View";
import { Modal } from "@mui/material";
import DialogContent from '@mui/material/DialogContent';
// import { KeyboardAvoidingView, Platform, Linking, Share } from "react-native-1app";
let _ref = null;

//nao atualizar
export default class PgModal extends React.Component {
  constructor(props) {
    super(props);
    _ref = this;
    this.state = {
      heranca: {},
      open: false,
      prop: {},
      Component: View,
      propsModal: {}
    };
  }



  openModal = (Component = View, prop = {}, propsModal = {}) => {
    this.setState({ Component, prop, propsModal, open: true })
    // this.refs.modal1.open()
  }
  closeModal = () => {
    this.setState({ open: !this.state.open })
    // this.refs.modal1.close()
  }

  render() {
    const { Component, prop, propsModal, styleModal = {} } = this.state;
    return (
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        open={this.state.open}
        style={{ overflow: 'scroll', }}
        onClose={this.closeModal}
        {...propsModal}
      >
        <DialogContent>
          <Component
            key="compe_modal"
            {...prop}
            style={{ ...prop.style }}
            closeModal={this.closeModal}
          />
        </DialogContent>
      </Modal>
    );
  }
}


export function openModal(...args) {
  if (_ref) {
    _ref.openModal(...args);
  }
}
export function closeModal(...args) {
  if (_ref) {
    _ref.closeModal(...args);
  }
}
